import { dividerClasses, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ExposuresListStyle: StyleExtend<Theme> = {
  gap: '1.5rem',
  borderBottom: (theme) => `1px solid ${theme.palette.customColors.lightGray}`,
  [`.${dividerClasses.root}`]: {
    borderColor: (theme) => theme.palette.customColors.lightGray,
  },
};
